import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BlogPost.css';
import { alexanderPost } from '../content/posts/alexanderpost';
import { ousterhoutPost } from '../content/posts/ousterhoot';
import { agileScience } from '../content/posts/AgileIsNotScientific';


const BlogPost = ({ postId }) => {
    // Map of post IDs to post objects
    const posts = {
        // 'alexander-notes-synthesis-form': alexanderPost,
        // 'ousterhout-notes': ousterhoutPost
        // 'software-engineering-science': agileScience

    };

    const post = posts[postId];

    useEffect(() => {
        if (post) {
            document.title = `${post.title} | David Dallas`;
        }
    }, [post]);

    if (!post) {
        return (
            <div className="blog-container">
                <div className="blog-error">Post not found</div>
                <Link to="/blog" className="back-to-blog">← Back to all posts</Link>
            </div>
        );
    }

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    return (
        <article className="blog-post-full">
            <header className="blog-post-header">
                <h3 className="blog-post-title">{post.title}</h3>
                <div className="blog-post-meta">
                    <time dateTime={post.date}>{formatDate(post.date)}</time>
                    <span className="meta-separator">•</span>
                    <span className="read-time">{post.readTime}</span>
                    <span className="meta-separator">•</span>
                    <span className="category">{post.category}</span>
                </div>
            </header>
            
            <div 
                className="blog-post-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
            />
            
            <footer className="blog-post-footer">
                <Link to="/blog" className="back-to-blog">← Back to all posts</Link>
            </footer>
        </article>
    );
};

export default BlogPost;